var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleTiles',{style:('--column-count:' + _vm.defaultNumberOfColumns),attrs:{"is-vertical":_vm.isVertical,"is-imaged":_vm.isImaged}},[_vm._l((_vm.jssTiles),function(tile,index){return [_c(_vm.getComponent(tile),{key:`tile${index}`,tag:"component"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }